module.exports = __webpack_public_path__ + "html/survey.template.html";